import { render } from "./city.html?vue&type=template&id=5866166e&scoped=true&ts=true"
import script from "./city.ts?vue&type=script&lang=ts"
export * from "./city.ts?vue&type=script&lang=ts"

import "./city.scss?vue&type=style&index=0&id=5866166e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5866166e"]])

export default __exports__